import React, { PropTypes } from 'react';
import { FormattedNumber } from 'react-intl';

const Distance = ({ value, imperial }) => {
  const toMiles = 0.00062137119;
  const toFeet = 3.2808399;

  let distance = value;
  let unit = 'm';
  let digits = 0;

  if (imperial) {
    if (value * toMiles < 0.25) {
      distance = value * toFeet;
      unit = 'ft';
    } else {
      distance = value * toMiles;
      unit = 'mi';
      digits = distance < 10 ? 1 : 0;
    }
  } else if (value > 250) {
    distance = value / 1000;
    unit = 'km';
    digits = 1;
  }

  return (
    <span className='distance'>
      <FormattedNumber
        value={distance}
        maximumFractionDigits={digits}
      />{ unit }
    </span>
  );
};

Distance.propTypes = {
  value: PropTypes.number.isRequired,
  imperial: PropTypes.bool,
};

Distance.defaultProps = {
  imperial: false,
};

export default Distance;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Distance/index.jsx